import { render } from "./leave-certificate.vue?vue&type=template&id=198be92e"
import script from "./leave-certificate.vue?vue&type=script&lang=js"
export * from "./leave-certificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__